import {
	Circle,
	Clock,
	PauseCircle,
	CheckCircle2,
	XCircle,
} from 'lucide-react'
import moment from 'moment'

interface StatusTask {
	taskStatus?: string
	completed?: boolean
	completedBy: string | Date
}

export const getStatusIcon = (task: StatusTask) => {
	const status = task.taskStatus || 'Open'
	const isCompleted = task.completed || false
	const dueDate = moment(task.completedBy)
	const isPastDue = !isCompleted && dueDate.isBefore(moment(), 'day')

	if (isPastDue) {
		return { icon: XCircle, color: '#e53e3e' }
	}

	switch (status) {
		case 'Open':
			return { icon: Circle, color: '#3082ce' }
		case 'In Progress':
			return { icon: Clock, color: '#38a169' }
		case 'On Hold':
			return { icon: PauseCircle, color: '#dd6b1f' }
		case 'Completed':
			return { icon: CheckCircle2, color: '#000000' }
		default:
			return { icon: Circle, color: '#3082ce' }
	}
}
